// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'rectangle';

export const Component = () => (
  <path d='M22 2H3a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h19a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Zm0 1v19H3V3h19Z' />
);

export const viewBox = '0 0 25 25';
